import { keysToSnake } from '#/api/adapters/wireCase';
import { serializePaymentPlan } from '#/api/srm/serializePaymentPlan';

function toNumberOrNull(value) {
  if (value === '' || value == null) {
    return null;
  }
  return Number(value);
}

function mapLine(line, { includeLineId }) {
  const mapped = {
    itemName: line?.itemName ?? '',
    specification: line?.specification || null,
    qty: toNumberOrNull(line?.qty),
    unitPrice: toNumberOrNull(line?.unitPrice),
    remark: line?.remark || null,
  };

  if (includeLineId) {
    mapped.lineId = line?.lineId || null;
  }

  return mapped;
}

function mapHeader(payload, { includeLineId, includeUpdatedAt }) {
  const body = {
    purchaseOrderDate: payload?.purchaseOrderDate || null,
    supplierName: payload?.supplierName ?? '',
    currencyId: payload?.currencyId || null,
    paymentTermId: payload?.paymentTermId || null,
    taxType: payload?.taxType || null,
    roundingMode: payload?.roundingMode || null,
    issueReason: payload?.issueReason || null,
    remark: payload?.remark || null,
    lines: (payload?.lines ?? []).map((line) => mapLine(line, { includeLineId })),
  };

  if (includeUpdatedAt) {
    body.updatedAt = payload?.updatedAt ?? null;
  }

  return keysToSnake(body);
}

/** 建立草稿。不送單號、updatedAt、lineId、金額或物料欄。 */
export function serializeMiscPurchaseOrderCreate(payload) {
  return mapHeader(payload, { includeLineId: false, includeUpdatedAt: false });
}

/** 草稿整批更新。既有行帶 lineId，新行 lineId 為 null。 */
export function serializeMiscPurchaseOrderUpdate(payload) {
  return mapHeader(payload, { includeLineId: true, includeUpdatedAt: true });
}

/**
 * 核准後異動草稿（建立／修改共用）。不改供應商名稱、幣別、匯率。
 * `paymentPlan` 選填：有期別才送；總額改變時後端要求必附。
 */
export function serializeMiscPurchaseOrderAmendment(payload) {
  const body = {
    issueReason: payload?.issueReason || null,
    remark: payload?.remark || null,
    updatedAt: payload?.updatedAt ?? null,
    taxType: payload?.taxType || null,
    roundingMode: payload?.roundingMode || null,
    lines: (payload?.lines ?? []).map((line) => mapLine(line, { includeLineId: true })),
  };
  const paymentPlan = serializePaymentPlan(payload?.paymentPlan);
  if (paymentPlan) {
    body.paymentPlan = paymentPlan;
  }
  return keysToSnake(body);
}
